import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'
import { useShouldHideTypeSelect } from '../../_helpers/shouldHideField'

const TypeSelect = ({ index, ...props }) => {
  const { t } = useTranslation('triggers')
  const payload_path = index >= 0 ? ['payload', index] : ['payload']
  const path = [...payload_path, 'typeSelect']
  const { handleChangeIn, form } = useFormState()

  const shouldHideTypeSelect = useShouldHideTypeSelect()

  const isFromNonComplianceEvent = ['non_compliance_event'].includes(form.entity)

  if (shouldHideTypeSelect()) return false

  const options = [
    { id: 'actionPlan', name: t('typeSelect.actionPlan') },
    { id: 'serviceOrder', name: t('typeSelect.activity') }
  ]

  const handleChange = value => {
    handleChangeIn([...payload_path, 'typeSelect'], value)

    const non_compliance_id = isFromNonComplianceEvent
      ? '::{{non_compliance_event.non_compliance_id}}'
      : '::{{non_compliance.id}}'

    if (value?.id === 'actionPlan') {
      handleChangeIn([...payload_path, 'type'], 'actionPlan')
      handleChangeIn([...payload_path, 'non_compliance_id'], non_compliance_id)
      return
    }
    handleChangeIn([...payload_path, 'type'], null)
    handleChangeIn([...payload_path, 'non_compliance_id'], null)
  }

  return (
    <FormItem
      label={t('triggers:fields.type')}
      path={path}
      Input={Select}
      options={options}
      {...props}
      onChange={handleChange}
    />
  )
}

export default TypeSelect
